import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminPanelService } from '../../services/admin-panel.service';
import { APIUrl } from '../../app-service-routing';
import { MatTableDataSource } from '@angular/material';

@Component({
  selector: 'app-transactiondetails',
  templateUrl: './transactiondetails.component.html',
  styleUrls: ['./transactiondetails.component.scss']
})
export class TransactiondetailsComponent implements OnInit {
  product = {};
  infoTable = [];
  productID: any;
  activeTransactions: any;
  infoTableDataSource = new MatTableDataSource(this.infoTable);
  displayedColumns: string[] = [
    "action",
    "amount",
    "transactionDate",
    "balance",
    "sender",
    "receiver",
    "company"
  ];
  constructor(private router: Router, private service: AdminPanelService, private activeRoute: ActivatedRoute, ) { }

  ngOnInit() {
    this.activeRoute.params.subscribe(routeParams => {
      this.productID = routeParams.id;
    });

    this.service.selectedtransactionsDetailSource.subscribe(cards => {
      if (cards) {
        this.product = cards;
      } else {
        this.router.navigate(['home/transactions'])
      }
    });

    this.transactiondetail(this.productID);
  }

  transactiondetail(productid) {
    this.service.getReseultSetList(APIUrl.transactiondeatil + productid).subscribe(response => {
      this.activeTransactions = response;
      this.infoTableDataSource = this.activeTransactions;
    }, error => {
    });
  }

  getColor(color) {
    switch (color) {
      case 'Deposit':
        return 'green';
      case 'Redeem':
        return 'red';
      case 'HK':
        return 'red';
    }
  }
  back() {
    this.router.navigate(['home/transactions'])
  }
}
